
















































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { ProductTypes } from "@/data/enums/products";

// Types
import { IState } from "@/store";
import { IBrand } from "@/models/brands";

import { IProduct, IProductCategory } from "@/models/products";

@Component({
  computed: {
    ...mapState({
      rootCategories(state: IState, getters) {
        return getters[`data/listArray`]({
          storeModule: DataModules.CATALOGUE_CATEGORIES,
          scope: this.rootCategoriesScope
        });
      },

      rootCategoriesScope(state: IState, getters) {
        return getters[
          `data/${DataModules.CATALOGUE_CATEGORIES}/rootCategoriesScope`
        ](this.promotionBrandId, this.productTypes);
      },
      product(state: IState, getters) {
        return getters[`data/single`]({
          storeModule: DataModules.CATALOGUE,
          scope: this.productScope(this.productId)
        });
      }
    }),
    ...mapGetters({
      productScope: "data/catalogue/scope"
    })
  }
})
export default class SelectProductWithPreview extends Mixins(
  RequestPromises,
  HasValidation
) {
  // Getters
  public rootCategoriesScope!: string;
  public rootCategories!: IProductCategory[];
  public product!: IProduct;
  public productScope!: Function;

  // Props
  @Prop({ required: true })
  public value!: IProduct["id"];

  @Prop({ required: true })
  public isDisabled!: boolean;

  @Prop({ required: true })
  public promotionBrandId!: IBrand["id"];

  @Prop({ required: true })
  public isUpdate!: boolean;

  @Prop({
    default: () => [ProductTypes.SINGLE_PRODUCT, ProductTypes.PRODUCT_BUNDLE]
  })
  public productTypes!: ProductTypes[];

  public get productId() {
    return this.value;
  }

  public set productId(value) {
    this.$emit("input", value);
  }

  // Data
  public isLoading = false;
  public isReloading = false;
  public requestError = false;

  public async created() {
    if (!this.contentIsAvailable) return;

    this.isLoading = true;
    this.loadData();
  }

  public async loadData() {
    try {
      await this.getRootCategories(this.isReloading);

      if (this.isUpdate || this.productId) {
        await this.getProductData();
      }

      this.requestError = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public getRootCategories(ignoreStored = false) {
    return this.$store.dispatch(
      `data/${DataModules.CATALOGUE_CATEGORIES}/list`,
      {
        productTypes: this.productTypes,
        scope: this.rootCategoriesScope,
        params: {
          order: "order",
          limit: 0,
          "filter[level]": 1,
          brand_id: this.promotionBrandId
        },
        vm: this,
        ignoreStored
      }
    );
  }

  public getProductData(ignoreStored = false) {
    return this.$store.dispatch(`data/${DataModules.CATALOGUE}/get`, {
      id: this.productId,
      scope: this.productScope(this.productId),
      params: {
        with: "image"
      },
      vm: this,
      ignoreStored
    });
  }

  public openSelectProductsModal() {
    if (this.isDisabled) return;
    this.$store.dispatch(
      `data/${DataModules.CATALOGUE}/openSelectProductsModal`,
      {
        props: {
          productTypes: this.productTypes,
          selectedProducts: this.product
            ? [this.$_.pick(this.product, ["id", "currency_id", "name"])]
            : [],
          isMultiselect: false
        },
        events: {
          success: async selectedProducts => {
            this.productId = selectedProducts[0].id;
          }
        }
      }
    );
  }

  public get parentCategories() {
    return this.getFullProductPath(
      this.rootCategories,
      this.$_.get(this.product, "category_id")
    );
  }

  public getFullProductPath(categories, categoryId: IProductCategory["id"]) {
    let path = [];

    function dive(_data, _path, _, level) {
      for (let i = 0; i < _data.length; i++) {
        if (_data[i].id === categoryId) {
          path = _.concat(_path, [
            { id: _data[i].id, name: _data[i].name, order: level }
          ]);
        } else if (_.has(_data[i], "subcategories")) {
          dive(
            _data[i].subcategories,
            _.concat(_path, [
              { id: _data[i].id, name: _data[i].name, order: level }
            ]),
            _,
            level + 1
          );
        }
      }
    }

    dive(categories, [], this.$_, 0);

    return path;
  }

  public binProduct(oldProductId) {
    this.$store.dispatch("data/bin", {
      storeModule: DataModules.CATALOGUE,
      scope: this.productScope(oldProductId),
      vm: this
    });
  }

  @Watch("productId")
  public onFormProductChange(newProductId, oldProductId) {
    if (oldProductId) this.binProduct(oldProductId);
    if (!newProductId) return;

    this.productId = newProductId;
    this.loadData();
  }

  public guardFunctionalities = [
    "staff_list_products",
    "list_product_categories"
  ];

  public get contentIsAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }

  // Getters
  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: DataModules.CATALOGUE_CATEGORIES,
      scope: this.rootCategoriesScope,
      vm: this
    });
    if (this.productId) {
      this.binProduct(this.productId);
    }
  }
}
